<template>
  <v-app class="blue-grey lighten-5">
    <v-toolbar app fixed clipped-left height="80">
      <img src="images/logo.svg" height="40">
      <v-toolbar-title class="logo">G<span>irl</span>P<span>ower</span>S<span>quad</span></v-toolbar-title>

      <v-spacer />

      <v-toolbar-items v-if="user" class="hidden-sm-and-down">
        <v-menu content-class="m-account-menu" open-on-hover transition="slide-y-transition">
          <v-btn slot="activator" flat class="m-account-button">
            {{ user.name }}
            <v-avatar size="48" color="blue-grey lighten-4">
              <img :src="'ext_storage/profilepics/' + user.id + '.jpg'">
            </v-avatar>
          </v-btn>
          <v-list class="mt-7">
            <v-list-tile @click.prevent="logout">
              <v-list-tile-title class="">
                {{ $t('generic.logout') }}
              </v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>

    <v-content>
      <v-container grid-list-md fluid fill-height class="pa-0">
        <child />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import Child from '../components/Child'

export default {
  name: 'MainLayout',

  components: {
    Child

  },

  data () {
    return {
      drawerOpen: false
    }
  },

  computed: mapGetters({
    user: 'auth/user'
  }),

  mounted: function () {
    this.goToLastPosition()
    console.log(this.$router.history.current)
  },

  methods: {
    async logout () {
      await this.$store.dispatch('auth/logout')
      this.$router.push({ name: 'login' })
    },

    goToLastPosition () {
      axios.get(`/api/position/get/`).then(({ data }) => {
        if (data) {
          if (data.position === 'personal') {
            this.$router.push({ name: 'personal' })
          } else if (data.position === 'char_select') {
            this.$router.push({ name: 'char_select' })
          } else if (data.position === 'spent') {
            this.$router.push({ name: 'spent' })
          } else if (data.position === 'dashboard') {
            this.$router.push({ name: 'dashboard' })
          } else {
            this.$router.push({ name: 'intro' })
          }
        } else {
          this.$router.push({ name: 'intro' })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/layouts/default.vue